document.addEventListener("DOMContentLoaded", function () {
  const infoIcons = document.querySelectorAll(".info-icon-container");
  if (!infoIcons.length) return;

  infoIcons.forEach((icon) => {
    icon.addEventListener("click", function (event) {
      if (window.innerWidth >= 768) return;

      for (const otherIcon of infoIcons) {
        if (otherIcon !== icon) {
          otherIcon.classList.remove("active");
        }
      }

      icon.classList.toggle("active");
      event.stopPropagation();
    });
  });

  document.addEventListener("click", function () {
    if (window.innerWidth >= 768) return;

    for (const icon of infoIcons) {
      icon.classList.remove("active");
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const counts = document.querySelectorAll("[data-byte-wishlist-count]");
  if (!counts.length) return;

  const sync = (el) => {
    el.dataset.count = (el.textContent || "").trim() || "0";
  };

  counts.forEach((el) => {
    sync(el);
    new MutationObserver(() => sync(el)).observe(el, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  });
});
